<template>
  <div class="login">
    <el-row class="login-container">
      <el-col :span="18" style="height: 100%">
        <img class="logo-pic" src="../../../common/img/loginBg.png">
        <div class="login_bgimg_title">{{$t('welcome_to_iceq')}}</div>
        <div class="login_bgimg_subtitle">{{$t('tenant_system')}}</div>
      </el-col>
      <el-col :span="6" class="login-form1">
        <div style="height:5%"></div>
        <div>
          <!-- <i class="iconfont icon-logo"></i> -->
          <img class="icon-logo" src="../assets/img/logo-icon.png" />
        </div>
        <div style="height:5%"></div>
        <el-form :model="form" ref="form" style="width: 76%;margin:0 auto;">
          <!-- <i class="iconfont icon-logo"></i> -->
          <el-form-item style="text-align: left;">
            <template>
              <el-row>
                <el-col :span="14" style="padding-left: 15px">
                  <span class="sign_in_tit">{{ $t('signIn') }}</span>
                </el-col>
                <el-col :span="10" class="earth-content">
                  <el-dropdown @command="onLangChanged">
                    <i class="icon-color earth-icon icon-Vector icon-pursor icon-24"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in languageOptions" :key="item.value" :command="item.value">{{item.label}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
          <el-form-item>
            <label class="el-form-item__label el-form-item__label_login" slot="label">{{ $t('email') }}</label>
            <el-input type="text" class="common-input" v-model="form.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <label class="el-form-item__label el-form-item__label_login" slot="label">{{ $t('password') }}</label>
            <el-input show-password class="common-input" v-model="form.password" @change="passwordChange" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button round type="primary" style="margin-top: 14px" class="common-input" :disabled="signInDisable" @click="handleSigninClick">{{ $t('signIn') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" round style="margin-top: 14px" class="common-input" @click="handleCreateClick">{{ $t('create_account') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" round style="margin-top: 14px" class="common-input" @click="handleForgotClick">{{$t('forgot_password')}}</el-button>
          </el-form-item>
          <!-- <div class="or_title">
            <span class="or-line"></span>
            <span style="margin: 0 29px;font-size: 14px;font-weight: bold;">{{$t('or')}}</span>
            <span class="or-line"></span>
          </div> -->
        </el-form>
        <div style="width:100%;height:auto;text-align:left;">
          <a href="https://www.somatime.com" class="login-tip">{{'www.somatime.com'}}</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import authInfoMgmt from '../auth-info-mgmt-inst';
import i18nMgmt from '../locale/i18n-mgmt-inst';

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      languageOptions: [],
      signInDisable: false,
      form: {
        email: '',
        password: '',
        language: ''
      }
    };
  },
  mounted() {
    this.languageOptions = i18nMgmt.getLangList();
    this.form.language = i18nMgmt.getCurLang();
  },
  methods: {
    onLangChanged(data) {
      this.form.language = data;
      const loading = this.$loading();
      i18nMgmt.setLang(this.$i18n, this.form.language).then(() => {
        loading.close();
      });
    },
    handleSigninClick() {
      authInfoMgmt
        .signInByEmail({
          email: this.form.email,
          password: this.form.password
        })
        .then((data) => {
          if (data.succeeded) {
            this.$router.push({
              path: '/productList'
            });
          }
        });
    },
    handleCreateClick() {
      this.$router.push({
        name: 'CreateCcount'
      });
    },
    handleForgotClick() {
      this.$router.push({
        name: 'ForgetPassword'
      });
    },
    passwordChange() {
      if (this.form.password.length < 6) {
        this.signInDisable = true;
      } else {
        this.signInDisable = false;
      }
    }
  }
};
</script>

<style lang="scss">
.login-form1 {
  background: #f4f4f4;
  height: 100%;
  position: relative;
  width: 25%;
  float: left;
  text-align: center;
}
.login {
  width: 100vw;
  height: 100vh;

  &-container {
    height: 100%;
    width: 100%;
  }

  .earth-content {
    text-align: right;
    padding-right: 20px;
    height: 48px;
    line-height: 48px;
  }

  .icon-24 {
    font-size: 24px;
  }

  .el-form-item__label_login {
    font-size: 16px;
    font-weight: bold;
    color: #292929;
    padding-left: 16px;
  }

  .common-input {
    width: 100%;
    height: 40px;
  }

  .forget_title {
    color: #2a2a2a;
    font-size: 12px;
    cursor: pointer;
    margin-top: 14px;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .icon-logo{
    width:auto;
    height:100px;
  }
}

.logo-pic {
  width: 50%;
  height: auto;
  margin-top: 7%;
}

.login_logo {
  color: #292929;
  font-size: 96px;
  font-weight: bold;
  margin-bottom: 20px;
}

.logingo {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.sign_in_tit {
  font-size: 34px;
  color: #292929;
  font-weight: bold;
  white-space: nowrap;
}

.login_bgimg_title {
  color: #203556;
  font-weight: bold;
  font-size: 55px;
  line-height: 66px;
  letter-spacing: 1.44px;
}

.login_bgimg_subtitle {
  font-size: 55px;
}

.or_title {
  color: #2a2a2a;
  font-weight: bold;
  font-size: 14px;
  margin: 3% 0;
}

.or-line {
  display: inline-block;
  width: 30%;
  height: 1px;
  background: #c4c4c4;
  vertical-align: middle;
}

.login-form {
  background: #f4f4f4;
  height: 100%;
  padding-top: 5%;
  position: relative;
}

.login-tip {
  // font-size: 12px;
  // color: #2a2a2a;
  position: absolute;
  bottom: 1%;
  text-align: center;
  width: 100%;
}

.logo {
  max-width: 100%;
  margin-left: -20px;
}
</style>